import { NavLink } from 'react-router-dom';
import { Download, GraduationCap, Home, Search, Star } from 'lucide-react';

const ITEMS = [
  { to: '/', label: 'Início', icon: Home, end: true },
  { to: '/search', label: 'Buscar', icon: Search, end: false },
  { to: '/study', label: 'Estudar', icon: GraduationCap, end: false },
  { to: '/favorites', label: 'Favoritos', icon: Star, end: false },
  { to: '/downloads', label: 'Offline', icon: Download, end: false },
] as const;

/**
 * Navegação inferior (F8-T03).
 *
 * Fica embaixo porque o iPhone é o dispositivo principal e tudo precisa ser
 * alcançável com o polegar de uma mão só (PLAN §14, critérios de aceite).
 */
export function BottomNavigation(): React.ReactElement {
  return (
    <nav
      aria-label="Navegação principal"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-800 bg-slate-900/95 pb-safe backdrop-blur"
    >
      <ul className="mx-auto flex max-w-md">
        {ITEMS.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex min-h-14 flex-col items-center justify-center gap-0.5 text-[0.6875rem] ${
                  isActive ? 'text-sky-400' : 'text-slate-400'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={22} aria-hidden strokeWidth={isActive ? 2.4 : 1.8} />
                  {label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
